module.exports = __webpack_public_path__ + "static/media/woody.e39caa00.jpg";